import { Link } from 'react-router';
import { Virtuoso } from 'react-virtuoso';
import { AvatarWithStatus } from '@/components/common/avatar-with-status';
import type { SameGroup } from '@/models/user/friend-info';
import ROUTES from '@/routes';
import cn from '@/utils/merge-class-names';
import AppCell from '../common/app-cell';

type Props = {
  itemClassName?: string;
  groups: SameGroup[];
};

export default function CommonGroupBlock({ groups, itemClassName }: Props) {
  return (
    <Virtuoso
      className='flex flex-1 flex-col items-stretch'
      data={groups}
      overscan={6}
      defaultItemHeight={56}
      increaseViewportBy={168}
      itemContent={(_, g) => (
        <Link
          key={g.ID}
          to={ROUTES.MESSAGES.GROUPS.$buildPath({ params: { id: g.ID } })}>
          <AppCell
            prefix={
              <AvatarWithStatus
                className='size-12'
                size={[48, 48]}
                imageUrl={g.GroupImg}
                label={g.GroupName}
                defaultAvatar='group'
              />
            }
            label={
              <div className='flex'>
                <div className='max-w-[196px] truncate pr-1'>{g.GroupName} </div>
                <span> ({g.UserCount})</span>
              </div>
            }
            className={cn('gap-4 px-0 py-2', itemClassName)}
            chevron
          />
        </Link>
      )}
    />
  );
}
